<div class="flex flex-col gap-4 justify-between py-2 fixed h-full w-[80px] bg-surface-container z-40 overflow-y-auto">

  <nav class="flex flex-col gap-4">
    @for (item of menuItems$$(); track $index) {
      @if (!item.restrictedFeature || storageService.getUserFeatures()?.[item.restrictedFeature]) {
        <a
          *hdHasAccess="item.rbacActionKey"
          class="menu-item"
          [routerLink]="item.link"
          [routerLinkActive]="'bg-surface-container-lowest'"
        >
          <i [ngClass]="item.icon" [ngStyle]="{'font-size': '20px'}"></i>
          <span class="caption-xs">{{ item.label | translate }}</span>
        </a>
      }
    }
  </nav>

  <div class="flex flex-col gap-4">
    <hd-side-menu-item class="menu-item" (click)="openFeedbackDialog()" icon="icon-menu-feedback" labelKey="menuitem.feedback"/>
    <hd-side-menu-item class="menu-item" [primaryTextColor]="true" (click)="openContactDialog()" icon="icon-menu-contact" labelKey="menuitem.contact"/>
    <hd-side-menu-item class="menu-item" (click)="logout()" icon="icon-menu-logout" labelKey="menuitem.logout"/>

    <a [attr.href]="HD_PUBLIC_WEB" target="_blank" class="cursor-pointer flex items-center justify-center">
      <i class="icon-menu-hypherdata-logo" [ngStyle]="{'font-size': '24px'}"></i>
    </a>
  </div>
</div>
